import React from 'react';

// Modern minimalist Qanun AI Logo - Clean Scale/Balance Design
export function QanunLogo({ className = "", showText = true, size = "default" }) {
  const sizes = {
    small: { icon: "w-8 h-8", text: "text-lg" },
    default: { icon: "w-9 h-9", text: "text-xl" },
    large: { icon: "w-11 h-11", text: "text-2xl" }
  };
  
  const { icon, text } = sizes[size] || sizes.default;
  
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className={`${icon} relative`}>
        <svg 
          viewBox="0 0 40 40" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          {/* Gradient background circle */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3B82F6" />
              <stop offset="100%" stopColor="#1D4ED8" />
            </linearGradient>
          </defs>
          
          {/* Circle background */}
          <circle cx="20" cy="20" r="20" fill="url(#logoGradient)" />
          
          {/* Stylized balance/scale icon - represents justice/law */}
          <path 
            d="M20 8V32M14 14L20 11L26 14M10 20C10 20 12 18 14 20C16 22 10 24 10 24M30 20C30 20 28 18 26 20C24 22 30 24 30 24"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          
          {/* Balance pans */}
          <ellipse cx="12" cy="22" rx="4" ry="1.5" fill="white" fillOpacity="0.9" />
          <ellipse cx="28" cy="22" rx="4" ry="1.5" fill="white" fillOpacity="0.9" />
        </svg>
      </div>
      
      {showText && (
        <span className={`${text} font-semibold text-gray-900 dark:text-white tracking-tight`}>
          Qanun<span className="text-blue-500 font-normal ms-0.5">AI</span>
        </span>
      )}
    </div>
  );
}

// Minimal version for chat/headers
export function QanunLogoMinimal({ className = "w-6 h-6" }) {
  return (
    <svg 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGradientMini" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      
      <circle cx="20" cy="20" r="20" fill="url(#logoGradientMini)" />
      
      <path 
        d="M20 8V32M14 14L20 11L26 14M10 20C10 20 12 18 14 20C16 22 10 24 10 24M30 20C30 20 28 18 26 20C24 22 30 24 30 24"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      <ellipse cx="12" cy="22" rx="4" ry="1.5" fill="white" fillOpacity="0.9" />
      <ellipse cx="28" cy="22" rx="4" ry="1.5" fill="white" fillOpacity="0.9" />
    </svg>
  );
}

export default QanunLogo;
